module.exports = __webpack_public_path__ + "static/img/equipment_new.233cace.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equipment_new.png
// module id = Sgyn
// module chunks = 128